import axios from "axios";
import { ENDPOINTS } from "./_config";

export const getTwilioToken = async () => {
  try {
    const response = await axios.get(ENDPOINTS.TWILIO_CALL.TWILIO_TOKEN);
    return response.data;
  } catch (error) {
    console.error("Error fetching Twilio token:", error);
    throw error;
  }
};

export const getLiveCallStatus = async (callSid) => {
  const url = `/api/twilioVoice/live-call-status/${callSid}`;

  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching call status:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// Example usage
//getLiveCallStatus('CA4a09f7a291beb54ce821eacdbffa5565');
